<div class="file-view-header au-forms">
	<au-cmms-entity-name
		class="entity-name"
		[name]="file.name"
		(inputBlur)="updateFileEntityName($event)"
	></au-cmms-entity-name>

	<div class="file-actions">
		<div class="file-tab-buttons">
			<mat-tab-group
				mat-stretch-tabs="false"
				mat-align-tabs="end"
				(selectedTabChange)="tabChanged($event)"
				[selectedIndex]="activeTab === 'view' ? 0 : 1"
			>
				<mat-tab [label]="'view' | translate" />
				<mat-tab [label]="'info' | translate" />
			</mat-tab-group>

			<div
				class="file-menu-button"
				matRipple
				matRippleColor="rgba(#1c4b31, 0.05)"
				[matRippleCentered]="true"
				[matMenuTriggerFor]="fileBtnMenu"
			>
				<mat-icon class="secondary-text-icon"> more_vert </mat-icon>
			</div>
		</div>
	</div>
</div>

<mat-menu #fileBtnMenu="matMenu" xPosition="before" class="actions-menu">
	<button mat-menu-item (click)="replaceFilePressed.emit()">
		<mat-icon class="accent-icon" svgIcon="upgrade"></mat-icon>
		{{ 'replace' | translate }}
	</button>

	<button mat-menu-item (click)="downloadFilePressed.emit()">
		<mat-icon class="accent-icon" svgIcon="download"></mat-icon>
		{{ 'download' | translate }}
	</button>

	<button mat-menu-item (click)="deleteFile()">
		<mat-icon class="critical-icon" svgIcon="delete"></mat-icon>
		{{ 'delete' | translate }}
	</button>
</mat-menu>
